// client/src/pages/Weddings/steps/DessertsStep/utils/constants.js
export const SUBCATEGORY_META = {
  cupcake: { label: "Cupcakes", hint: "Choose flavors by the dozen" },
  macaron: { label: "Macarons", hint: "Classic French sandwich cookies" },
  cookie: { label: "Cookies", hint: "Assorted gourmet cookies" },
  cakeSlice: { label: "Cake Slices", hint: "Individual servings" },
  cheesecakeSlice: {
    label: "Cheesecake Slices",
    hint: "Individual cheesecake portions",
  },
  pastry: { label: "Pastries", hint: "Assorted desserts & pastries" },
};

export const SUBCAT_ORDER = [
  "cupcake",
  "macaron",
  "cookie",
  "cakeSlice",
  "cheesecakeSlice",
  "pastry",
];
